import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useOrganization } from "@/contexts/OrganizationContext";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { ShieldX } from "lucide-react";

interface AnalyticsProtectedRouteProps {
  children: ReactNode;
}

/** Acesso apenas para roles admin, manager ou owner. Rep não pode acessar. */
export function AnalyticsProtectedRoute({ children }: AnalyticsProtectedRouteProps) {
  const { currentOrg, loading } = useOrganization();
  const navigate = useNavigate();

  const canAccess =
    currentOrg &&
    (currentOrg.role === "admin" || currentOrg.role === "manager" || currentOrg.role === "owner");

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        <span className="ml-2 text-muted-foreground">Verificando permissões...</span>
      </div>
    );
  }

  if (!canAccess) {
    return (
      <div className="container mx-auto px-6 py-8">
        <Alert variant="destructive">
          <ShieldX className="h-4 w-4" />
          <AlertDescription>
            Acesso negado. A página de Analytics está disponível apenas para administradores e gerentes.
          </AlertDescription>
        </Alert>
        <Button
          variant="outline"
          className="mt-4"
          onClick={() => navigate("/dashboard")}
        >
          Voltar ao Dashboard
        </Button>
      </div>
    );
  }

  return <>{children}</>;
}
